import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  searchMedia
} from "actions/media";

import _ from "lodash";
import cx from "classnames";
import Truncate from "react-truncate";
import { IKImage } from 'imagekitio-react';

import { Button, Nav, Tab, Dropdown } from "react-bootstrap";

import { MediaUploadButton } from "../index";
import InfiniteScroll from "components/InfiniteScroll";

import styles from "./mediaPalette.module.scss";

const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export const MediaPaletteView = ({ storyboard, target, mediaTypes = ['image', 'video'], multiple, handleMediaLibrary, onSelect, mediaLibrary }) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    active: 'image',
    selected: []
  })

  const uploads = useSelector(state => _.get(state, 'media.uploads')) || [];
  const mediaTarget = useSelector(state => _.get(state, 'media.mediaTarget')) || null;
  const mediaList = useSelector(state => _.get(state, 'media.items')) || [];
  const dataFetched = useSelector(state => _.get(state, 'media.fetched'));
  const loading = useSelector(state => _.get(state, 'media.loading'));
  const pagination = useSelector(state => _.get(state, 'media.pagination'));
  const uploadError = useSelector(state => _.get(state, 'media.uploadError'))
  const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

  useEffect(() => {
    if (!mediaLibrary) {
      handleSearchMedia();
    }
  }, [mediaLibrary])

  const handleTabChange = (active) => {
    setState(state => {
      return {
        ...state,
        active: active
      }
    })
  }

  const openMediaLibrary = (e) => {
    e.stopPropagation()
    handleMediaLibrary()
  }

  const handleSearchMedia = () => {
    const request = {
      storyboard: _.get(storyboard, 'id'),
      target: target,
      mediaTypes: mediaTypes,
      page: 0,
      limit: 20,
      sort: 'modifiedDate',
      order: 'desc'
    };

    dispatch(searchMedia(request));
  }

  const loadMoreMedia = (mediaType) => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    const request = {
      storyboard: storyboard.id,
      target: target,
      page: pagination.currentPage + 1,
      mediaTypes: mediaType,
      limit: 20,
      sort: 'modifiedDate',
      order: 'desc'
    };

    dispatch(searchMedia(request));
  }

  const handleClick = (media) => {
    var updated = [...state.selected];

    if (multiple) {
      const exists = updated.find(m => m.id === media.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== media.id);
      } else {
        updated = [...updated, media];
      }
    } else {
      updated = [media];
    }
    
    setState(state => {
      return {
        ...state,
        selected: updated
      }
    })
  }

  useEffect(() => {
    if ((uploads.length > 0 || uploadError) && mediaTarget != 'social_share') {
      handleMediaLibrary()
    }
  }, [uploads, uploadError])

  const renderTabsIcon = (icon, title) => {
    return (
      <div className={styles.tabsButton}>
        <i className={`cleverstory-${icon}`} />
        <span className={styles.tabsTitle}>{title}</span>
      </div>
    )
  }

  if (dataFetched && uploads.length === 0 && mediaList.length === 0) {

    return (
      <EmptyMessage storyboard={storyboard} target={target} mediaTypes={mediaTypes} openMediaLibrary={openMediaLibrary} />
    )
  }

  return (
    <div className={styles.mediaPalette}>
      <Tab.Container id="left-tabs-example" defaultActiveKey="image" onSelect={handleTabChange}>
        <div className={cx(styles.palatteHeader, 'handle')}>
          <Nav className={styles.navigationTabs}>
            <Nav.Item>
              <Nav.Link active={state.active === 'image'} eventKey="image">{renderTabsIcon('background', 'images')}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link active={state.active === 'video'} eventKey="video">{renderTabsIcon('video', 'videos')}</Nav.Link>
            </Nav.Item>
          </Nav>

          <div className={styles.tabsButtonTray}>
            <UploadContent storyboard={storyboard} target={target} mediaTypes={mediaTypes} openMediaLibrary={openMediaLibrary} />
          </div>
        </div>
        <div className={styles.tabContentView}>
          <InfiniteScroll
            className={cx(styles.scrollable)}
            loading={loading}
            hasMore={hasMoreItems}
            loadMore={() => {
              loadMoreMedia([state.active]);
            }}
          >
            <Tab.Content>
              {state.active === 'image' &&
                <Tab.Pane eventKey="image">
                  {mediaList.map(media => {
                    let active = state.selected.some(data => data.id === media.id);
                    if (media.type !== 'image') {
                      return null;
                    }
                    return <Media key={media.id}
                      media={media}
                      selected={active}
                      onClick={() => {
                        handleClick(media);
                      }}
                    />
                  })}
                </Tab.Pane>}
              {state.active === 'video' &&
                <Tab.Pane eventKey="video">
                  {mediaList.map(media => {
                    let active = state.selected.some(data => data.id === media.id);
                    if (media.type !== 'video') {
                      return null;
                    }
                    return (
                      <Video key={media.id}
                        muted
                        media={media}
                        selected={active}
                        onClick={() => {
                          handleClick(media);
                        }}
                      />
                    )
                  })
                  }
                </Tab.Pane>}
            </Tab.Content>
          </InfiniteScroll>
        </div>
      </Tab.Container>
      <div className={styles.actionContainer}>
        <Button variant="primary" disabled={_.size(state.selected) === 0}
          onClick={() => {
            onSelect(state.selected);
          }}
          className={styles.actionButton}>
          Choose Media
        </Button>
      </div>
    </div>
  )
}

const UploadContent = ({ openMediaLibrary, storyboard, mediaTypes }) => {

  return (
    <Button  onClick={openMediaLibrary} className={styles.uploadMediaBtn}>
       <i className={cx('cleverstory-grid-view', styles.uploadIcon)} />Media Library
    </Button>
  )
}

export const Media = ({ media, selected, onClick }) => {

  return (
    <div className={cx(styles.media)} onClick={onClick}>
      <div className={cx(styles.icon, { [styles.selected]: selected })}>
        <IKImage path={media.url}
          transformation={[{
            "width": "600"
          }]}
          loading="lazy" />
      </div>
      <div className={styles.name}>
        <i className={cx("cleverstory-background")} />
        <span className={styles.label}>
          <Truncate lines={1}>{media.name}</Truncate>
        </span>
      </div>
    </div>
  );
}

export const Video = ({ media, selected, onClick }) => {
  const videoRef = React.useRef(null);

  useEffect(() => {
    if (selected) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [selected]);

  return (
    <div className={cx(styles.media)} onClick={onClick}>
      <div className={cx(styles.icon, styles.videoIcon, { [styles.selected]: selected })}>
        <video name="media" ref={videoRef} className={styles.videoPlayer} autoPlay loop muted>
          <source src={`${IMAGE_CDN_ENDPOINT}/${media.url}`} />
        </video>
      </div>
      <div className={styles.name}>
        <i className={cx("cleverstory-video")} />
        <span className={styles.label}>
          <Truncate lines={1}>{media.name}</Truncate>
        </span>
      </div>
    </div>
  )
}

export const EmptyMessage = ({storyboard, target, mediaTypes, openMediaLibrary, disabled=false}) => {
  
  return (
    <div className={styles.emptyMediaContainer} >
    <div className={styles.emptyMessage}>
      <img className={cx(styles.emptyMediaImage)} src='' alt="emptyMedia_image" />
     {!disabled && 
        <Button variant="light" className={styles.emptyUploadButton}>
          <i className={cx('cleverstory-upload', styles.uploadIcon)} />Upload Media
          <MediaUploadButton
            className={styles.fileUpload}
            storyboard={storyboard} 
            target={target}
            mediaTypes={mediaTypes}
            onSelect={openMediaLibrary}
          />
        </Button>
     }
      <div className={styles.errorMessageContent}>
        <div className={styles.errorMessageTitle}>
          <h2 className={styles.heading}>Weather forecast</h2>
        </div>
        <div className={styles.errorMessageSubText}>
          <span>Clear skies and <br /> empty screens</span>
        </div>
      </div>
    </div>
  </div>
  )
}